module.exports = __webpack_public_path__ + "static/media/pdf.581b9bea.svg";